import { render, staticRenderFns } from "./webBanners.vue?vue&type=template&id=6a162f21&scoped=true"
import script from "./webBanners.vue?vue&type=script&lang=js"
export * from "./webBanners.vue?vue&type=script&lang=js"
import style0 from "./webBanners.vue?vue&type=style&index=0&id=6a162f21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a162f21",
  null
  
)

export default component.exports